const lang = {
	EN: {
		basket: 'Basket',
		favorite: 'Favorites',
		home: 'Home',
		search: 'Search',
		profile: 'Profile'
	},

	'': {
		basket: 'Корзина',
		favorite: 'Избранное',
		home: 'Главная',
		search: 'Поиск',
		profile: 'Профиль'
	},
	KZ: {
		basket: 'Себет',
		favorite: 'Таңдаулылар',
		home: 'үй',
		search: 'Іздеу',
		profile: 'Профиль'
	},
	ARM: {
		basket: 'Զամբյուղ',
		favorite: 'Ֆավորիտներ',
		home: 'տուն',
		search: 'Որոնում',
		profile: 'Անձնագիր'
	}
};

export { lang };
